import type { UrlMatchResult, UrlSegment } from '@angular/router';

export function urlMatcher<T extends Record<string, U>, U>(segments: UrlSegment[], enumObj: T): UrlMatchResult | null {
    if (segments.length === 0) {
        return null;
    }
    const first = segments[0]?.path;

    if (Object.values(enumObj).includes(first as U)) {
        // Only consume the first segment, let child routes handle the rest
        return { consumed: [] };
    }

    return null;
}
